import React from 'react'
import './Footer.css';
import { FaMailBulk, FaPhone, FaSearchLocation } from 'react-icons/fa'
import { SiDoordash, SiGoogle, SiYelp } from "react-icons/si";

const Footer = () => {
    return (
        <div className='footer'>
            <div className='footer-container'>
                <div className='left'>
                    <div className='location'>
                        <FaSearchLocation size={20} style={{ color: '#ffffff', marginRight: '2rem' }} />
                        <div>
                            <p>295 5th ave</p>
                            <h4>New York, NY</h4>
                        </div>
                    </div>
                    <div className='phone'>
                        <h4><FaPhone size={20} style={{ color: '#ffffff', marginRight: '2rem' }} /> 1-800-233-1212</h4>
                    </div>
                    <div className='email'>
                        <h4><FaMailBulk size={20} style={{ color: '#ffffff', marginRight: '2rem' }} /> nyeats@foodie.com</h4>
                    </div>
                </div>
                <div className='right'>
                    <h4>About the company</h4>
                    <p>We partner with local farmers and even have our own NewYork Eats farm in Long Island, where we grow
                        produce with the goal of providing hyper-local seasonal fruits and veggies to all of our nyc
                        restaurants.

                        Our innovative menu is one of a kind, as we take special care of our vegan, vegetarian, gluten-free,
                        and meat-lover guests. All of our food, dressings, soups, and sauces are prepared in-house daily,
                        ensuring that every meal is...just made. just for you.
                    </p>
                    <div className='social'>
                        <SiDoordash size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                        <SiYelp size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                        <SiGoogle size={30} style={{ color: '#ffffff', marginRight: '1rem' }} />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer
